import { Card, Typography } from 'antd'
import React, { useState } from 'react'
import { useBillingSelector } from 'store/billingSlice/billingReducer'
import { SubscriptionTabs } from './components/SubscriptionTabs'
import { ChangePlanModal } from './components/ChangePlanModal'
import InfoCard from './components/InfoCard'
import { ChangePaymentMethodModal } from './components/ChangePaymentMethodModal'
import NotificationBar from './components/NotificationBar'

const SubscripionDetails = () => {
  const { subscription } = useBillingSelector()
  const [showChangetierModal, setShowChangeTierModal] = useState(false)
  const [showPaymentMedthodModal, setShowPaymentMethodModal] = useState(false)

  return (
    <Card
      bordered={false}
      style={{ minHeight: 'calc(100vh - 205px)' }}
      className="t-p-7"
    >
      <Typography className="t-font-roboto t-text-[1.5rem] md:t-text-[1.625rem] t-font-bold t-leading-[1.75rem] md:t-leading-[1.904375rem] t-mb-3">
        Subscription details
      </Typography>
      <div className="t-grid t-grid-cols:1 md:t-grid-cols-10 t-gap-4 md:t-gap-8">
        <div className="md:t-col-span-6">
          <NotificationBar />
          <div>
            <SubscriptionTabs />
          </div>
        </div>
        <Card className="md:t-col-span-4 t-h-[450px]">
          <InfoCard
            setShowChangeTierModal={setShowChangeTierModal}
            setShowPaymentMethodModal={setShowPaymentMethodModal}
          />
        </Card>
      </div>
      {showChangetierModal && (
        <ChangePlanModal
          visible={showChangetierModal}
          onClose={() => setShowChangeTierModal(false)}
          organizationTier={subscription?.TierId}
        />
      )}
      {showPaymentMedthodModal && (
        <ChangePaymentMethodModal
          visible={showPaymentMedthodModal}
          onClose={() => setShowPaymentMethodModal(false)}
        />
      )}
    </Card>
  )
}

export { SubscripionDetails }
